import { Form, Select } from "antd";

export const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select
        style={{
          width: 80,
        }}
      >
        <Select.Option value="966">+966</Select.Option>
      </Select>
    </Form.Item>
);

export const createTransactionID = (isCorrelationId = false) => {
  let currentDateTime = new Date()
      .toISOString()
      .replace(/-|:|T/gi, '')
      .replace('.', '')
      .slice(2)
      .slice(0, -1)
  return (
      'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}

export const RandomStringID = (length: number, chars: string) => {
  var mask = '';
  if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
  if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (chars.indexOf('#') > -1) mask += '0123456789';
  var result = '';
  for (var i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
  return result;
}